import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["result"]
  async submit(event) {
    event.preventDefault()
    this.resultTarget.textContent = "Checking routing…"
    try {
      const response = await fetch(this.element.action, { method: "POST", body: new FormData(this.element), headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" } })
      const result = response.headers.get("content-type")?.includes("application/json") ? await response.json() : {}
      if (!response.ok) throw new Error(result.error || "Routing could not be checked.")
      const hosts = result.hosts.map(host => host.name)
      const required = (result.required_hosts || []).map(host => host.name)
      const cohosts = required.length ? ` · Required co-hosts: ${required.join(", ")}` : ""
      if (!hosts.length) {
        this.resultTarget.textContent = `Manual review required · ${result.facts.crm_state || result.reason.replaceAll("_", " ")}`
      } else if (result.reason === "collective") {
        this.resultTarget.textContent = `Organizer: ${hosts[0]}${cohosts} · Everyone must be available`
      } else {
        const label = result.reason === "rotation" ? "Rotation order" : "Preferred hosts"
        this.resultTarget.textContent = `${label}: ${hosts.join(" → ")}${cohosts} · First available host attends`
      }
    } catch (error) { this.resultTarget.textContent = error.message }
  }
}
